import xlsxExport from '../../shared/xlsxExport/xlsxExport';

import { SheetExportTypes } from '@common/xlsxExport/xlsxExport.constants';

export default ({
  reportData,
  description,
  fileName,
  totalColumnName,
  displayGroupingColumnsByPercentages,
  hideDecimals,
  negativeMinus,
  shouldDisplayZero,
}) => {
  const sheetData = [
    {
      name: 'Effective Tax Rate (ETR)',
      data: reportData,
      type: SheetExportTypes.ETR_REPORT,
      options: {
        numberOfAdditionalRowsToStick: 1,
        numberOfColumnsToStick: 5,
        totalColumnName,
        displayGroupingColumnsByPercentages,
        hideDecimals,
        negativeMinus,
        shouldDisplayZero,
        addTimestamp: true,
        aggregationFields: ['tagDescription', 'descr', 'countryTaxTypeDescription', 'companyCode'],
      },
    },
  ];

  xlsxExport({
    sheetData,
    metadata: {
      description,
      fileName,
    },
  });
};
